import { p as printNoDefaultExport, d as defineCreateClientExports, S as SanityClient, e as envMiddleware } from "./_chunks-es/browserMiddleware.js";
import { B, b, C, O, f, c, P, a, T } from "./_chunks-es/browserMiddleware.js";
import { adapter, environment } from "get-it";
function defineDeprecatedCreateClient(createClient2) {
  return function(config) {
    return printNoDefaultExport(), createClient2(config);
  };
}
const exp = defineCreateClientExports(envMiddleware, SanityClient), requester = exp.requester, createClient = exp.createClient, deprecatedCreateClient = defineDeprecatedCreateClient(createClient);
export {
  B as BasePatch,
  b as BaseTransaction,
  C as ClientError,
  O as ObservablePatch,
  f as ObservableSanityClient,
  c as ObservableTransaction,
  P as Patch,
  SanityClient,
  a as ServerError,
  T as Transaction,
  createClient,
  deprecatedCreateClient as default,
  requester,
  adapter as unstable__adapter,
  environment as unstable__environment
};
//# sourceMappingURL=index.browser.js.map
